export enum LokaliseKeys {
  BRUSSELS = '2D040DCF-F1A7-457C-B6BA-47F81ECD4A40',
  FLANDERS = '7943467B-05F4-43B0-8E8B-779B8A76191A',
  WALLONIA = 'AECFCFE1-AAC4-4E5B-AE53-2F85EFB7C2E2',
  WORKER = '4D471EBF-D95D-4F1E-8632-9A99E96C5C0A',
}
